<template>
  <div>
    <v-dialog scrollable v-model="model" persistent max-width="800px">
      <material-card
        v-if="model && item"
        :title="
          $t('components.plan_fee_guides.add_plan_fee_guide_{0}', [
            guideTitle(),
          ])
        "
        icon="add"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col xs="12">
                  <pbas-date-picker
                    :value="item.EffectiveDate"
                    @update-date="item.EffectiveDate = $event"
                    :label="$t('globals.effective_date')"
                    :rules="[$rules.required]"
                    class="required"
                  ></pbas-date-picker>
                </v-col>
                <v-col xs="12" v-if="plan === null || plan === undefined">
                  <v-autocomplete
                    v-model="item.Plan"
                    :label="$t('globals.plan')"
                    :items="plansWithoutFeeGuides"
                    :item-text="(item) => item.Number"
                    item-value="PlanId"
                    :rules="[$rules.required]"
                    class="required"
                    return-object
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <trans-select
                    :clearable="true"
                    :item="item"
                    propertyName="Province"
                    :items="provincesList"
                    :label="$t('globals.province')"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-select>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <v-autocomplete
                    :clearable="true"
                    :label="$t('headers.t4a_archive.year')"
                    v-model="year"
                    clear-icon="clear"
                    :items="years"
                    :rules="[$rules.required]"
                    class="required"
                    item-value="Year"
                    item-text="Year"
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-autocomplete
                    :clearable="true"
                    v-model="geolocation"
                    :items="geolocations"
                    :label="
                      $t('components.guides.import_guide_dialog.geolocation')
                    "
                    clear-icon="clear"
                    :rules="[$rules.required]"
                    class="required"
                    item-value="GeoLocation"
                    :item-text="(item) => translateEnum(item)"
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <v-autocomplete
                    :clearable="true"
                    :label="
                      $t('components.guides.health_reasonable_customary.guides')
                    "
                    v-model="guide"
                    clear-icon="clear"
                    :items="guides"
                    item-text="Name"
                    return-object
                    :rules="[$rules.required]"
                    class="required"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <pbas-data-table
            ref="table"
            :dataProvider="provider"
            :showSelect="true"
            @error="error = $event"
            :exporters="$exporters"
            :noSearch="true"
            :noFilters="true"
          ></pbas-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancel">{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="!isValid()"
            color="primary"
            :loading="saving"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import ErrorHandler from "../../components/ErrorHandler.vue";
import { translate2 } from "../../trans2";
import { mapActions, mapGetters } from "vuex";
import TransEnum from "../TransEnum.vue";
import TransSelect from "../TransSelect.vue";
import { ODataProvider } from "pbas-vue-components";
import getHeaders from "@/headers/FeeGuides";
export default {
  props: ["model", "assignment", "coverage", "plan", "brokerId"],
  components: {
    ErrorHandler,
    TransEnum,
    TransSelect,
  },
  data() {
    return {
      error: null,
      successDialog: false,
      valid: false,
      saving: false,
      loading: false,
      item: {},
      plansWithoutFeeGuides: [],
      feeGuides: [],
      provincesList: null,
      guides: [],
      years: [],
      provinces: [],
      geolocations: [],
      provider: undefined,
      selected: [],
      guide: null,
      year: null,
      geolocation: null,
    };
  },
  computed: {
    ...mapGetters("common", ["settings"]),
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language"]),
    title() {
      if (this.assignment) {
        return this.$t(
          "components.benefits.benefit_form_dialog.edit_benefit_{}",
          [translate2(this.assignment, "Name")]
        );
      }
      return this.$t("components.benefits.benefit_form_dialog.add_benefit");
    },
  },
  watch: {
    "item.Province": {
      handler(v) {
        if (v) {
          console.log(v);
          let province = this.provinces.filter((o) => o.ProvinceId === v.Id)[0];
          this.years = province.Years;
          this.year = null;
          this.guide = null;
          this.geolocation = null;
          if (this.years.length === 1) {
            this.year = this.years[0];
          }
        }
      },
    },
    year: {
      handler(v) {
        if (v) {
          this.geolocations = v.GeoLocations;
          if (this.geolocations.length === 1) {
            this.geolocation = this.geolocations[0];
          }
          this.loadData();
        }
      },
    },
    guide: {
      handler(v) {
        console.log("guide: ", v);
        if (v) {
          this.loadData();
        }
      },
    },
    geolocation: {
      handler(v) {
        if (v) {
          this.guides = v.Names;
          if (this.guides.length === 1) {
            this.guide = this.guides[0];
          }
          this.loadData();
        }
      },
    },
    model: {
      handler(v) {
        if (v) {
          // if (this.assignment) {
          //   this.item = JSON.parse(JSON.stringify(this.assignment));
          // } else {
          this.item = {
            Plan: this.plan,
          };
          // }
          this.provider = undefined;
          this.load();
        }
      },
    },
  },
  methods: {
    ...mapActions("claims", [
      "getPlansWithoutFeeGuides",
      "addPlanFeeGuide",
      "getFeeGuides",
    ]),
    translateEnum(item) {
      return this.$t(`enums.${item.GeoLocation}`);
    },
    guideTitle() {
      if (this.coverage === "Health") {
        return this.$t("views.guides.health_reasonable_&_customary_guides_2");
      }
      return this.$t("views.guides.dental_fee_guides");
    },
    isValid() {
      if (
        this.item.EffectiveDate === null ||
        this.item.EffectiveDate === undefined
      ) {
        return false;
      }
      if (this.$refs.table === null || this.$refs.table === undefined) {
        return false;
      }
      console.log("is valid called 2!", JSON.stringify(this.item));
      if (this.item.Plan === null || this.item.Plan === undefined) {
        return false;
      }
      console.log("is valid called 3!", JSON.stringify(this.item));
      if (
        this.item.Plan.ClaimSettings === null ||
        this.item.Plan.ClaimSettings === undefined
      ) {
        return this.$refs.table.selected.length === 1;
      }
      console.log("valid item: ", this.item);
      if (this.item.Plan.ClaimSettings.FeeGuideProvince === "Single") {
        return this.$refs.table.selected.length === 1;
      }
      console.log("is valid: ", this.valid, this.$refs.table.selected.length);
      return this.$refs.table.selected.length > 0;
    },
    cancel() {
      this.$emit("close");
    },
    async load() {
      try {
        this.loading = true;
        this.plansWithoutFeeGuides = (
          await this.getPlansWithoutFeeGuides({
            coverage: this.coverage,
            brokerId: this.brokerId,
          })
        ).data.value;
        this.provinces = (
          await this.getFeeGuides({
            coverage: this.coverage,
          })
        ).data;
        this.provincesList = this.options.Models.Province.filter(
          (o) =>
            this.provinces.filter((oo) => oo.ProvinceId === o.Id).length > 0
        );
        this.item = {
          Plan: this.plan,
        };
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    save() {
      let item = JSON.parse(JSON.stringify(this.item));
      console.log(item);
      item.ProvinceId = item.Province.Id;
      item.PlanId = item.Plan.PlanId;
      item.FeeGuideIds = this.$refs.table.selected.map((o) => o.Id);
      delete item.Province;
      if (item.Id) {
        return this.update(item);
      }
      return this.add(item);
    },
    async add(item) {
      try {
        this.saving = true;
        await this.addPlanFeeGuide({
          payload: item,
        });
        this.$emit("success");
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async update(item) {
      try {
        this.saving = true;
        await this.updateBenefit({
          id: item.Id,
          payload: item,
        });
        this.$emit("success");
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    loadData() {
      const filter = this.createFilter();
      console.log("loadData: ", filter, this.provider);
      if (filter) {
        if (this.provider === undefined) {
          this.provider = new ODataProvider(
            this.$axiosHttp,
            this.settings.APIURL + "fee-guides",
            getHeaders()
          );
          this.provider.filter = filter;
        } else {
          this.provider.filter = filter;
          this.$refs.table.getDataAsync();
        }
      } else {
        this.provider = undefined;
      }
    },
    createFilter() {
      let filters = [];
      console.log("filter: ", this.item.Province, this.guide, this.year, this.geolocation);
      if (
        this.guide === null ||
        this.guide === undefined ||
        this.year === null ||
        this.year === undefined ||
        this.item.Province === null ||
        this.item.Province === undefined ||
        this.geolocation === null ||
        this.geolocation === undefined
      ) {
        return null;
      }
      filters.push(`Name eq '${this.guide}'`);
      filters.push(`Year eq ${this.year.Year}`);
      filters.push(`ProvinceId eq ${this.item.Province.Id}`);
      filters.push(`GeoLocation eq '${this.geolocation.GeoLocation}'`);
      filters.push(`Coverage eq '${this.coverage}'`);
      return filters.join(` and `);
    },
  },
};
</script>

<style></style>
